import { useState } from 'react';

import {
  type TopicsActions,
  type Topic,
} from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/types';
import { enableScroll } from 'helpers/scroll';

export const useSidePreview = (topicsActions: TopicsActions, topic: Topic) => {
  const [isSidePreviewOpen, setIsSidePreviewOpen] = useState(false);

  const handleManageGroupClick = () => {
    setIsSidePreviewOpen(true);
    enableScroll(false);
  };

  const handleSidePreviewClose = () => {
    setIsSidePreviewOpen(false);
    topicsActions.fetchTopic(topic.id);
    enableScroll();
  };

  return {
    isSidePreviewOpen,
    handleManageGroupClick,
    handleSidePreviewClose,
  };
};
